import { render, staticRenderFns } from "./wave-svg.vue?vue&type=template&id=7fdf9030"
var script = {}
import style0 from "./wave-svg.vue?vue&type=style&index=0&id=7fdf9030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports